export default __webpack_public_path__ + "static/media/maintenance-bg.ad76ca80.jpg";